// extracted by mini-css-extract-plugin
export default {"Services":"Services_Services__GlTKT"};